<script>
    import List, { Item, Text, PrimaryText, SecondaryText } from "@smui/list";
    import { createEventDispatcher } from "svelte";
    import { post } from "../http";
    import loading from "./loading";
    import snackbar from "./snackbar";

    export let origin, destination, weight;
    export let lastRefresh = null;

    let dispatch = createEventDispatcher();

    $: calculate(origin, destination, weight, lastRefresh);

    let packages = [];
    let selectedPackage = null;

    function selectPackage(pkg) {
        selectedPackage = pkg;
        dispatch("select", selectedPackage);
    }

    function calculate() {
        if (origin == "" || destination == "" || weight == "") return;
        loading.show();
        post("/api/calculate_fee", {
            origin_code: origin,
            destination_code: destination,
            weight: weight,
        })
            .then((resp) => {
                if (resp.status == 0) {
                    if (resp.data != null)
                        // packages = resp.data.filter(
                        //     (val) =>
                        //         val.service == "REG" ||
                        //         val.service == "BBM" ||
                        //         val.service == "BEST" ||
                        //         val.service == "GOKIL",
                        // );
                        packages = resp.data;
                    if (packages.length == 1) selectPackage(packages[0]);
                } else {
                    snackbar.open(resp.message);
                }
            })
            .finally(() => loading.hide());
    }
</script>

{#if packages.length > 0}
    <div class="shipping-kind">
        {#if packages.length > 1}
            <div class="text">Pilih jenis pengiriman di bawah ini:</div>
        {/if}
        <List class="address" threeLine>
            {#each packages as pkg}
                <Item
                    on:SMUI:action={() => selectPackage(pkg)}
                    selected={selectedPackage == pkg}
                >
                    <Text>
                        <PrimaryText>
                            {pkg.service}
                            -
                            {pkg.description}
                        </PrimaryText>
                        <SecondaryText>Estimasi: {pkg.etd}</SecondaryText>
                        <SecondaryText>Tarif: {pkg.tariff}</SecondaryText>
                    </Text>
                </Item>
            {/each}
        </List>
    </div>
{/if}
